<template>
  <div class="extra-details">
    <NavHeader
      :title="$t('screens.extraDetails.headerTitle')"
      @onBackClick="goBack"
    />
    <LayoutCard v-if="initialLoad" :loading="true" rounded>
      <div class="d-flex justify-center align-center" style="height: 200px;">
        <v-progress-circular indeterminate />
      </div>
    </LayoutCard>
    <div v-else>
      <LayoutCard
        :title="$t('screens.extraDetails.formTitle')"
        rounded
        required
      >
        <div class="pb-0">
          <div v-for="(field, key) in additionalFields" :key="key">
            <v-autocomplete
              v-if="field.type === 'autocomplete'"
              :key="field.key + '-autocomplete'"
              v-model="details[field.key]"
              :rules="[
                () =>
                  !field.required ||
                  !!details[field.key] ||
                  $t('generic.requiredField'),
              ]"
              :label="$t(field.placeholder)"
              :placeholder="$t(field.placeholder)"
              :items="
                field.select_options.map(option => ({
                  label: $t(option),
                  value: option,
                }))
              "
              item-text="label"
              item-value="value"
              class="py-3"
              color="black"
            ></v-autocomplete>
            <v-select
              v-else-if="field.type === 'select'"
              :key="field.key"
              v-model="details[field.key]"
              :rules="[
                () =>
                  !field.required ||
                  !!details[field.key] ||
                  $t('generic.requiredField'),
              ]"
              :label="$t(field.placeholder)"
              :placeholder="$t(field.placeholder)"
              :items="
                field.select_options.map(option => ({
                  label: $t(option),
                  value: option,
                }))
              "
              item-text="label"
              item-value="value"
              class="py-3"
              color="black"
            ></v-select>
            <v-checkbox
              v-else-if="field.type === 'checkbox'"
              :key="field.key + '-checkbox'"
              v-model="details[field.key]"
              :rules="[
                () =>
                  !field.required ||
                  !!details[field.key] ||
                  $t('generic.requiredField'),
              ]"
              :label="$t(field.placeholder)"
              color="black"
            ></v-checkbox>
            <v-text-field
              v-else
              :key="field.key + '-text'"
              v-model="details[field.key]"
              :rules="[
                () =>
                  !field.required ||
                  !!details[field.key] ||
                  $t('generic.requiredField'),
              ]"
              :label="$t(field.placeholder)"
              :placeholder="$t(field.placeholder)"
              type="text"
              class="py-3"
              maxlength="100"
              color="black"
            ></v-text-field>
          </div>
        </div>
      </LayoutCard>
      <LayoutCard rounded>
        <PriceSummary :subtotal-amount="subtotalAmount" :show-total="false" />
      </LayoutCard>
      <div class="px-10">
        <Button
          dark
          :disabled="!formValid || placingOrder"
          :loading="placingOrder"
          data-cy="confirm-details"
          @click="confirmOrder"
        >
          {{ $t('screens.extraDetails.payCtaLabel') }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import NavHeader from '@/components/Navigation/NavHeader.vue';
import LayoutCard from '@/components/LayoutCard.vue';
import Button from '@/components/Button.vue';
import PriceSummary from '@/components/common/PriceSummary.vue';

export default {
  components: {
    NavHeader,
    LayoutCard,
    Button,
    PriceSummary,
  },
  data() {
    return {
      initialLoad: false,
      details: {},
      placingOrder: false,
    };
  },
  computed: {
    subtotalAmount() {
      return this.$store.getters.getSubtotalAmountInFoodCourtCart;
    },
    additionalFields() {
      return this.$store.getters.getFoodCourtAdditionalOrderFields;
    },
    placeOrdersIds() {
      return this.$store.getters.getPlaceOrdersIds;
    },
    formValid() {
      if (!this.additionalFields) {
        return false;
      }

      const fields = this.additionalFields;
      const details = this.details;
      const valid = fields.every(field => {
        if (field.required) {
          return (
            (details[field.key] && details[field.key].length > 0) ||
            details[field.key] === true
          );
        }

        return true;
      });

      return valid;
    },
    hasCartItems() {
      return this.$store.getters.hasFoodCourtCartItems;
    },
  },
  async mounted() {
    if (!this.hasCartItems) {
      this.initialLoad = true;
    }

    await this.$store.dispatch('fetchFoodCourtCarts');

    this.initialLoad = false;
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async confirmOrder() {
      this.placingOrder = true;

      try {
        await this.$store.dispatch('placeMultiMerchantOrders', {
          details: this.details,
        });
      } catch (error) {
        this.placingOrder = false;
        return;
      }

      this.navigateToPaymentScreen();

      this.placingOrder = false;
    },
    navigateToPaymentScreen() {
      this.$router.push({
        name: 'FoodCourtPayment',
        params: {
          foodCourtHash: this.$route.params.foodCourtHash,
          placedOrdersIds: this.placeOrdersIds.join(','),
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.extra-details {
  padding-bottom: 100px;
}

.float {
  position: fixed;
  width: 100%;
  max-width: $max-app-width;
}
</style>
